if (!customElements.get('get-the-look-slider')) {
  customElements.define(
    'get-the-look-slider',
    class GetTheLookSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-look-track]');
        this.prevButton = this.querySelector('[data-look-prev]');
        this.nextButton = this.querySelector('[data-look-next]');

        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.syncFrame = null;
        this.onPrevClick = () => this.page(-1);
        this.onNextClick = () => this.page(1);
        this.onScroll = () => this.scheduleSync();

        this.prevButton.addEventListener('click', this.onPrevClick);
        this.nextButton.addEventListener('click', this.onNextClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(() => this.scheduleSync());
          this.resizeObserver.observe(this.track);
        }

        this.syncArrows();
      }

      disconnectedCallback() {
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
      }

      page(direction) {
        this.track.scrollBy({
          left: this.track.clientWidth * direction,
          behavior: 'smooth',
        });
      }

      scheduleSync() {
        if (this.syncFrame) cancelAnimationFrame(this.syncFrame);

        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = null;
          this.syncArrows();
        });
      }

      syncArrows() {
        const scrollLeft = Math.abs(this.track.scrollLeft);
        const visibleWidth = this.track.clientWidth;
        const totalWidth = this.track.scrollWidth;
        const overflows = totalWidth - visibleWidth > 1;

        this.prevButton.hidden = !overflows || scrollLeft <= 1;
        this.nextButton.hidden = !overflows || scrollLeft + visibleWidth >= totalWidth - 1;
      }
    }
  );
}
